<template>
    <article class="i-checkboxes">
        <div class="i-checkboxes__scroll">
            <ul class="i-checkboxes__list">
                <li
                    v-if="data.items.length > 2"
                    class="i-checkboxes__item i-checkboxes__item--checkAll">
                    <input
                        class="visually-hidden"
                        type="checkbox"
                        @change="checkboxesHandler(data.name + '-all')"
                        v-model="checkboxes"
                        :value="data.name + '-all'"
                        :name="data.name"
                        :id="data.name + '-all'" />
                    <label :for="data.name + '-all'">
                        <span class="i-checkboxes__text">
                            Все категории
                        </span>
                    </label>
                </li>
                <li
                    v-for="(item, i) in data.items"
                    :key="item.id"
                    class="i-checkboxes__item">
                    <input
                        class="visually-hidden"
                        type="checkbox"
                        @change="checkboxesHandler(item.id)"
                        v-model="checkboxes"
                        :value="item.id"
                        :name="data.name"
                        :id="item.id" />
                    <label :for="item.id">
                        <span
                            class="i-checkboxes__decor"
                            :style="{backgroundColor: item.color}"></span>
                        <span
                            class="i-checkboxes__text"
                            v-html="item.text"></span>
                    </label>
                </li>
            </ul>
        </div>
    </article>
</template>

<script>
    export default {
        name: "Checkboxes",
        props: {
            data: {
                type: Object,
                default: () => {}
            },
            choosenEmitent: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                checkboxes: ['emitents-all'],
            }
        },
        methods: {
            checkboxesHandler (el) {
                const checkedAll = 'emitents-all'
                if (el === checkedAll) {
                    this.checkboxes = [checkedAll]
                    this.$emit('modelChange', this.checkboxes)
                    return
                }

                if (this.checkboxes[0] === checkedAll) {
                    const [, ...filteredCheckboxes] = this.checkboxes
                    this.checkboxes = filteredCheckboxes
                }

                if (this.data.items.length === this.checkboxes.length) {
                    this.checkboxes = [checkedAll]
                }

                this.$emit('modelChange', this.checkboxes)
            }
        },
        beforeMount() {
            if (this.choosenEmitent) {
                this.checkboxes = this.choosenEmitent
                this.checkboxesHandler(this.choosenEmitent)
            }
        }
    }
</script>